import { combineReducers } from "redux";
import auth, { AuthState } from "./slices/auth";
import school, { SchoolState } from "./slices/school";
import lesson, { LessonState } from "./slices/lesson";
import course, { CourseState } from "./slices/course";
import subject, { SubjectState } from "./slices/subject";
import resource, { ResourceState } from "./slices/resource";
import grade, { GradeState } from "./slices/grade";
import program, { ProgramState } from "./slices/program";
import calendar, { CalendarState } from "./slices/calendar";
import gameQuiz, { GameQuizState } from "./slices/gameQuiz";
import tiendaColegioSlice, { TiendaColegioState } from "./slices/tiendaColegio";
import tiendaPaqueteSlice, { TiendaPaqueteState } from "./slices/tiendaPaquete";
import ventasSlice, { VentasState } from "./slices/ventas";
import { apiSlice } from "./api/apiSlice";

export type RootState = {
  auth: AuthState;
  school: SchoolState;
  lesson: LessonState;
  course: CourseState;
  subject: SubjectState;
  resource: ResourceState;
  grade: GradeState;
  program: ProgramState;
  calendar: CalendarState;
  gameQuiz: GameQuizState;
  tiendaColegio: TiendaColegioState;
  tiendaPaquete: TiendaPaqueteState;
  ventas: VentasState;
  [apiSlice.reducerPath]: ReturnType<typeof apiSlice.reducer>;
};

const reducer = combineReducers({
  auth: auth.reducer,
  school: school.reducer,
  lesson: lesson.reducer,
  course: course.reducer,
  subject: subject.reducer,
  resource: resource.reducer,
  grade: grade.reducer,
  program: program.reducer,
  calendar: calendar.reducer,
  gameQuiz: gameQuiz.reducer,
  tiendaColegio: tiendaColegioSlice.reducer,
  tiendaPaquete: tiendaPaqueteSlice.reducer,
  ventas: ventasSlice.reducer,
  [apiSlice.reducerPath]: apiSlice.reducer,
});

export default reducer;
